export default "__VITE_ASSET__Bky4JmwP__"